
<script>
  // 折れ線グラフ
  import { Line } from 'vue-chartjs'

  export default {
    extends: Line,

    props: ['chartData'],

    mounted() {
      this.render()
    },

    watch: {
      chartData: {
        deep: true,
        handler() {
          this.render()
        }
      }
    },

    methods: {
      render() {
        this.renderChart(this.chartData, {
          responsive: true,

          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function(tooltipItem, data) {
                const label = data.datasets[tooltipItem.datasetIndex].label
                const value = tooltipItem.yLabel
                return label + ': ' + value + '人'
              }
            }
          },

          legend: {
            position: 'bottom'
          },

          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  callback: function(value) {
                    return value + '人'
                  }
                }
              }
            ]
          }
        })
      }
    }
  }
</script>